var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilledoff = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.7 1C5.79 1 1 5.79 1 11.7c0 5.91 4.79 10.7 10.7 10.7 5.91 0 10.7-4.79 10.7-10.7C22.4 5.79 17.61 1 11.7 1ZM2.4 11.7a9.3 9.3 0 1 1 18.6 0 9.3 9.3 0 0 1-18.6 0Zm7.65-.055L15 7.105 13.986 6l-6.155 5.645 6.155 5.645L15 16.183l-4.95-4.54Z"
})));
export { SvgFilledoff as ReactComponent };
export default __webpack_public_path__ + "c0625883c3634c751c34e2bf72cda806.svg";